import { render, staticRenderFns } from "./CosmeticAllergies.vue?vue&type=template&id=21d52e01"
import script from "./CosmeticAllergies.vue?vue&type=script&lang=js"
export * from "./CosmeticAllergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports